import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { minusCircleIcon, bookIcon } from 'src/app/app-icons';
import { TrainingCategoryModel } from 'src/app/models/training-category/training-category.model';

@Component({
  selector: 'app-catalogue-selector',
  standalone: false,
  templateUrl: './catalogue-selector.component.html',
  styleUrl: './catalogue-selector.component.scss',
})
export class CatalogueSelectorComponent {
  @Input() isViewMode = false;

  @Input() trainingCategories: TrainingCategoryModel[] = [];
  @Input() trainingCategoryIds: string[] = [];

  @Output() trainingCategoryIdsChange = new EventEmitter<string[]>();
    
  get getTrainingCategoryLabel(): string {
    const trainingCategoriesStr = this.translateService.instant(
      'COMMON.FIELDS.TRAINING-CATEGORIES'
    );
    const optionalStr = this.translateService.instant(
      'COMMON.OPTIONAL'
    );
    return `${trainingCategoriesStr} (${optionalStr})`
  }

  constructor(
    private translateService: TranslateService,
    private sanitizer: DomSanitizer
  ) {}

  onTrainingCategorySelected(e: any): void {
    if (e.node.selected) {
      this.trainingCategoryIds = [
        ...this.trainingCategoryIds,
        e.node.key,
      ];
    } else {
      this.trainingCategoryIds =
        this.trainingCategoryIds.filter(id => id !== e.node.key);
    }

    this.trainingCategoryIdsChange.emit(this.trainingCategoryIds);
  }

  getTrainingCatalogueText(): string {
    const categories = this.trainingCategories
      .filter(x => this.trainingCategoryIds.includes(x.id))
      .map(x => x.name);

     return this.translateService.instant(
      'CATALOGUE.LISTED-IN-CATALOGUE',
      {
        categories: categories.join(', ')
      }
    );
  }

  getMinusCircleIcon() {
    return this.sanitizer.bypassSecurityTrustHtml(minusCircleIcon);
  }

  getBookIcon() {
    return this.sanitizer.bypassSecurityTrustHtml(bookIcon);
  }
}
